import { createMuiTheme } from '@material-ui/core/styles';
import colors from './colors';

const palette = {
    primary: {
        light: colors.buttonGreen,
        main: colors.buttonGreen,
        contrastText: '#fff',
    },
    secondary: {
        main: colors.buttonBlue,
    },
    text: {
        primary: colors.textPrimary,
    },
    accent1Color: colors.buttonBlue, // used for dropdown text color for selected item and date time picker
};

export default createMuiTheme({
    typography: {
        fontFamily: 'Helvetica Neue,Helvetica,Arial,sans-serif',
        suppressWarning: true,
    },
    palette,
    Button: {
        color: colors.buttonGrey,
    },
    appBar: {
        textColor: colors.textPrimary,
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1600,
        },
    },
    overrides: {
        MuiIconButton: {
            root: {
                padding: '0px 12px',
            },
        },
        MuiSwitch: {
            colorSecondary: {
                '&$checked': {
                    color: colors.buttonGreen,
                    '& + $bar': {
                        backgroundColor: colors.buttonGreen,
                    },
                },
            },
            switchBase: {
                height: 'auto',
            },
        },
        MuiCheckbox: {
            colorSecondary: {
                '&$checked': {
                    color: colors.buttonGreen,
                },
            },
        },
        MuiRadio: {
            colorSecondary: {
                '&$checked': {
                    color: colors.buttonGreen,
                },
            },
        },
        MuiFormControl: {
            root: {
                marginTop: '14px',
            },
        },
        MuiTableCell: {
            root: {
                padding: '0px 24px',
            },
        },
    },
});
